module.exports = __webpack_public_path__ + "static/media/Hospitality_65.ae85dd3a.jpg";